export default __webpack_public_path__ + "static/erwin_van_liempt-476390f43a83a04f0dc03891ed83ed62.jpg";